module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/dollar-69bd12d345058d0cfcea62525694d075.svg";